import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-fbd163e6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex flex-col" }
const _hoisted_2 = { class: "flex lg:flex-row flex-col gap-4" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "text-[16px]" }

import { Component, PropType, Ref, ref } from "vue";

export interface Tab {
  name: string;
  view: Component;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'TabTemplate',
  props: {
  tabs: {
    type: Array as PropType<Array<Tab>>,
    required: true,
  },
},
  setup(__props) {

const props = __props;



const activeTab: Ref<Tab | null> = ref(props.tabs[0]);

const setTab = (tab: Tab) => {
  activeTab.value = tab;
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.tabs, (tab) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "flex rounded-full border overflow-hidden",
          key: tab.name,
          onClick: ($event: any) => (setTab(tab))
        }, [
          _createElementVNode("div", {
            class: _normalizeClass(["cursor-pointer w-full lg:w-[155px] h-[40px] flex justify-center items-center unselected-tab", {
            'font-bold selected-tab': tab.name == activeTab.value?.name,
          }])
          }, [
            _createElementVNode("p", _hoisted_4, _toDisplayString(tab.name), 1)
          ], 2)
        ], 8, _hoisted_3))
      }), 128))
    ]),
    (_openBlock(), _createBlock(_resolveDynamicComponent(activeTab.value?.view)))
  ]))
}
}

})